module.exports = __webpack_public_path__ + "assets/img/qywx.2cd9060f.png";